import { render } from "./BaseForm.vue?vue&type=template&id=f838af20&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=f838af20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f838af20"

export default script